import { useState } from 'react';
import { X } from 'lucide-react';

interface AlertBannerProps {
  message: string;
}

const AlertBanner = ({ message }: AlertBannerProps) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-orange-500 text-white py-3 px-4 relative">
      <div className="container mx-auto flex justify-between items-center">
        <p className="text-sm md:text-base text-center flex-grow">{message}</p>
        <button 
          onClick={() => setIsVisible(false)}
          className="p-1 rounded-full hover:bg-orange-600 transition-colors"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default AlertBanner;